import script from "./NoteStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./NoteStatusBadge.vue?vue&type=style&index=0&id=3d1c4990&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1c4990"]])

export default __exports__